import { render, staticRenderFns } from "./EstadisticaPesos.vue?vue&type=template&id=e1ab386a&scoped=true"
import script from "./EstadisticaPesos.vue?vue&type=script&lang=js"
export * from "./EstadisticaPesos.vue?vue&type=script&lang=js"
import style0 from "./EstadisticaPesos.vue?vue&type=style&index=0&id=e1ab386a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ab386a",
  null
  
)

export default component.exports